import {
  FormControl,
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import { SyntheticEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldWrapper } from '@buildwise/libs/people';
import { useBuildWiseModules } from '@buildwise/libs/helpers';
import { styled } from '@mui/material/styles';

const STATUS = ['Active', 'Inactive'];
const USER_ROLES = ['ROLE_COMPANY_ADMIN', 'ROLE_COMPANY_USER'];

function UserOtherFields() {
  const { pluralProjectsModuleName } = useBuildWiseModules();
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext();

  return (
    <>
      <FieldWrapper id="role" label="Role" required disabled={isSubmitting}>
        <Controller
          control={control}
          render={({ field: { ref, ...field }, fieldState, ...rest }) => (
            <FormControl fullWidth>
              <Autocomplete
                {...field}
                freeSolo
                autoHighlight
                value={field.value || null}
                onChange={(_: SyntheticEvent<Element>, value: string | null) =>
                  setValue('role', value || '', { shouldDirty: true, shouldValidate: true })
                }
                onInputChange={(_: SyntheticEvent<Element>, value: string) =>
                  setValue('role', value || '', { shouldDirty: true, shouldValidate: true })
                }
                options={USER_ROLES}
                noOptionsText="No Roles Found"
                id="role"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="role"
                    inputRef={ref}
                    error={!!fieldState.error}
                    helperText={fieldState?.error?.message || ''}
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    placeholder="Role"
                    disabled={rest.formState.isSubmitting}
                  />
                )}
              />
            </FormControl>
          )}
          name="role"
        />
      </FieldWrapper>
      <FieldWrapper id="active" label="Status" required disabled={isSubmitting}>
        <Controller
          control={control}
          render={({ field: { ref, ...field }, fieldState, ...rest }) => (
            <FormControl fullWidth>
              <Autocomplete
                {...field}
                freeSolo
                autoHighlight
                value={field.value || null}
                onChange={(_: SyntheticEvent<Element>, value: string | null) =>
                  setValue('active', value || '', { shouldDirty: true, shouldValidate: true })
                }
                onInputChange={(_: SyntheticEvent<Element>, value: string) =>
                  setValue('active', value || '', { shouldDirty: true, shouldValidate: true })
                }
                options={STATUS}
                noOptionsText="No Roles Found"
                id="active"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="active"
                    inputRef={ref}
                    error={!!fieldState.error}
                    helperText={fieldState?.error?.message || ''}
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    placeholder="Status"
                    disabled={rest.formState.isSubmitting}
                  />
                )}
              />
            </FormControl>
          )}
          name="active"
        />
      </FieldWrapper>

      <$Header as="h3">User Permissions</$Header>
      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label="Can endorse content"
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canEndorseFlag"
      />

      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label="Can suggest revisions to posts"
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canSuggestRevisiontToPostsFlag"
      />

      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label="Can move posts to the top of the feed"
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canMovePostsToTopFlag"
      />

      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label="Can create new collections"
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canCreatePlaylistFlag"
      />

      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label="Can invite new users"
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canInviteOthersFlag"
      />

      <Controller
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormControl sx={{ display: 'block', mt: -1 }}>
            <FormControlLabel
              {...field}
              control={<Checkbox />}
              label={`Can add new ${pluralProjectsModuleName.toLowerCase()}`}
              checked={field.value}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name="canAddProjects"
      />
    </>
  );
}

const $Header = styled(Typography, { label: 'Header' })(({ theme }) => ({
  fontWeight: 700,
  fontSize: 20,
  color: theme.palette.custom.black,
  margin: '0 0 12px',
}));

export default UserOtherFields;
